var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "library-card dummy-card" }, [
    _c("div", { staticClass: "card-cover-img-thumb" }),
    _vm._v(" "),
    _c("div", { staticClass: "card-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 card-info-section" }, [
          _c("h4", { staticClass: "card-title typography--title" }),
          _vm._v(" "),
          _c("small", { staticClass: "typography--caption" }),
          _vm._v(" "),
          _c("div", { staticClass: "card-bottom-desc" }, [
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-action" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03f4abd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f4abd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DummyCard.vue
// module id = 0K6s
// module chunks = 1